<template>
  <div class="main">
    <!--顶部-->
    <div class="trendtop orangeToYellow">
      <div class="trendtop_left fs40 ellipsis" :class="ischange == true ? 'on' : ''" @click="showChangeTrend">
        <p>{{ dname }}</p>
      </div>
      <!-- <div class="trendtop_right fs24">
                {{ retime }}
                <img
                    src="../../assets/images/refresh.png"
                    class="img1 animate"
                    :class="isreferesh == true ? 'on' : ''"
                    @click="doReferesh"
                />
      </div>-->
    </div>
    <div class="ctn">
      <!-- 设备picker选择 -->
      <van-popup v-model="ishow" position="bottom" :style="{ height: '40%' }" @click-overlay="onCancel">
        <van-picker :title="$t('trend.trend_chose')" :confirm-button-text="$t('member.login_out_ok')" :cancel-button-text="$t('member.login_out_cancel')" show-toolbar :columns="monlist" :default-index="des" @confirm="onConfirm" @cancel="onCancel" />
      </van-popup>
      <!--顶部 end-->
      <!--时间段选择-->
      <div class="times">
        <div class="tim atime">
          <div class="starttime" @click="setTime(1)">{{ time1 }}</div>
          <van-popup v-model="istart" position="bottom" @click-overlay="setShade">
            <van-datetime-picker @confirm="doConfirm" @cancel="doCancel" type="datetime" :title="$t('export.time_title')" :confirm-button-text="$t('member.login_out_ok')" :cancel-button-text="$t('member.login_out_cancel')" :min-date="new Date(2019, 5, 1)" :max-date="smaxDate" />
          </van-popup>
        </div>
        <div class="tim btime">
          <div class="starttime" @click="setTime(2)">{{ time2 }}</div>
          <van-popup v-model="iend" position="bottom" @click-overlay="setShade">
            <van-datetime-picker v-model="currentDate" @confirm="doConfirm" @cancel="doCancel" type="datetime" :title="$t('export.time_title')" :confirm-button-text="$t('member.login_out_ok')" :cancel-button-text="$t('member.login_out_cancel')" :min-date="eminDate" :max-date="emaxDate" />
          </van-popup>
        </div>
      </div>
      <!--时间段选择 end-->
      <!--邮箱文本框-->
      <div class="foremail">
        <input type="text" v-model="email" :placeholder="$t('export.email_placeholder')" />
      </div>
      <div class="doexcel" @click="doSendEmail">
        {{ $t("export.sendemai") }}
      </div>
      <div class="tips">一次导出数据的最大范围在一个月的区间</div>
    </div>

    <div class="footer">
      <customFooter :ison="1"></customFooter>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentDate: new Date(),
      index: 0,
      kind: 0,
      ishow: false,
      ischange: false,
      isreferesh: false,
      no: localStorage.getItem("no") ? localStorage.getItem("no") : "",
      dname: localStorage.getItem("dname") ? localStorage.getItem("dname") : "", //设备名称
      monlist: [],
      istart: false,
      iend: false,
      itype: 1,
      sminDate: new Date(2019, 5, 1),
      smaxDate: new Date(), // 当前时间
      eminDate: new Date(2019, 5, 1),
      emaxDate: new Date(), // 当前时间
      email: "",
      time1: this.$setime(new Date() - 60 * 60 * 24 * 1000, 3),
      time2: this.$setime(new Date(), 3),

      chart: "",
      devicelist: "", //所有设备列表
      choselist: "", //选中的设备
      des: "", //选中设备索引
      retime: "", //最后更新时间
      relist: "", //属性列表
      nowre: "", //当前选择的属性
      thlist: ""
    };
  },
  created () { },
  mounted () {
    //创建图表
    this.$nextTick(function () {
      this.getDeviceList();
    });
  },
  methods: {
    //设备选择
    showChangeTrend () {
      this.ishow = true;
      this.ischange = true;
    },

    setShade () {
      this.ischange = false;
      this.ishow = false;
    },

    //时间选择取消
    doConfirm (value) {
      var dat = this.$setime(value, 3);
      if (this.itype == 1) {
        this.istart = false;
        this.time1 = dat;
      } else {
        this.iend = false;
        this.time2 = dat;
      }
    },
    doCancel () {
      if (this.itype == 1) {
        this.istart = false;
      } else {
        this.iend = false;
      }
    },

    //时间选择
    setTime (i) {
      if (i == 1) {
        this.istart = true;
      } else if (i == 2) {
        this.iend = true;
      }
      this.itype = i;
    },

    //查询设备列表
    getDeviceList (num) {
      this.$toast.loading({
        message: this.$t("live.read_loading"),
        forbidClick: true,
        duration: 0
      });
      var _this = this;
      this.$api
        .getDeviceList({})
        .then(res => {
          _this.$toast.clear();
          if (res.errcode == 0) {
            var des = _this.des;
            var dname = _this.dname;
            var devicelist = res.data;
            var choselist = "";
            var monlist = new Array();
            if (!_this.$isblank(devicelist)) {
              if (_this.$isblank(dname)) {
                des = 0;
              } else {
                for (var i = 0; i < devicelist.length; i++) {
                  if (devicelist[i].deviceName == dname) {
                    des = i;
                  }
                }
              }
              for (var i = 0; i < devicelist.length; i++) {
                monlist.push(devicelist[i].deviceName);
              }

              choselist = devicelist[des];
              _this.choselist = choselist;
              _this.devicelist = devicelist;
              _this.des = des;
              _this.monlist = monlist;

              localStorage.setItem("no", choselist["no"]);
              localStorage.setItem("dname", choselist["deviceName"]);

              //_this.getLiveDetail(choselist.no);
              _this.$refs.pageToast.type = 0;
            } else {
              //没有设备列表
              _this.$refs.pageToast.type = 1;
            }
          } else {
            //其他异常
            _this.$toast.clear();
            _this.$toast("暂无数据");
          }
        })
        .catch(err => {
          //其他异常
          _this.$toast.clear();
          //_this.$toast("连接超时22");
        });
    },

    //设备点击
    onConfirm (value, index) {
      this.retime = "";
      this.relist = "";
      this.nowre = "";
      this.ishow = false;
      this.ischange = false;
      this.dname = value;
      localStorage.setItem("dname", value);
      var devicelist = this.devicelist;
      var choselist = "";
      var des = this.des;
      if (!this.$isblank(devicelist)) {
        if (this.$isblank(this.dname)) {
          des = 0;
        } else {
          for (var i = 0; i < devicelist.length; i++) {
            if (devicelist[i].deviceName == value) {
              console.log(devicelist[i].deviceName, value);
              des = i;
              this.no = devicelist[i].no;
            }
          }
        }
        choselist = devicelist[des];
        localStorage.setItem("no", choselist.no);
        this.des = des;
        this.choselist = choselist;
        //this.getLiveDetail(choselist.no);
      }
    },

    //设备选择取消
    onCancel (e) {
      this.ischange = false;
      this.ishow = false;
    },

    //发送邮件
    doSendEmail () {
      var no = this.no;
      var email = this.email;
      var time1 = this.time1;
      var time2 = this.time2;
      if (this.$isblank(no)) {
        this.$toast(this.$t("export.tis_dev"));
        return false;
      }
      if (this.$isblank(email)) {
        this.$toast(this.$t("export.tis_email"));
        return false;
      }
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (!reg.test(email)) {
        this.$toast(this.$t("export.tis_fm"));
        return false;
      }

      if (!time1 || !time2 || time1 > time2) {
        this.$toast(this.$t("export.tis_time"));
        return false;
      }

      console.log("123123:", time1, time2, new Date(time1.replaceAll("-", "/")).getTime);
      const t1 = new Date(time1.replaceAll("-", "/")).getTime()
      const t2 = new Date(time2.replaceAll("-", "/")).getTime()
      const n = 1000 * 60 * 60 * 24 * 31 // 三个月
      if (t1 + n < t2) {
        this.$toast("一次导出数据的最大范围在一个月的区间");
        return false;
      }
      console.log(time1, time2);

      var _this = this;
      this.$toast.loading({
        message: this.$t("export.send_loading"),
        forbidClick: true,
        duration: 0
      });
      this.$api
        .doSendEmail({
          no: this.no,
          toMail: email,
          startDate: time1 + ":00",
          endDate: time2 + ":59"
        })
        .then(res => {
          _this.$toast.clear();
          if (res.errcode == 0) {
            _this.$toast.success(_this.$t("export.send_success"));
            // setTimeout(function() {
            //   // location.reload();
            // }, 1500);
            _this.email = "";
            _this.time1 = _this.$setime(new Date() - 60 * 60 * 24 * 1000, 3);
            _this.time2 = _this.$setime(new Date(), 3);
          } else {
            _this.$toast(res.errmsg);
          }
        });
    }
  }
};
</script>

<style>
body,
html {
  height: 100%;
  background: #f4f4f4;
}
.main {
  height: 100%;
}
/*top*/
.trendtop {
  overflow: hidden;
  padding: 10px 10px;
  box-sizing: border-box;
  z-index: 9999999999;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
  text-align: center;
  max-width: 6.4rem;
  /* margin: 0.6rem auto 0; */
  background: #fff;
  border-radius: 0.1rem;
  line-height: 30px;
  margin: auto;
}
.trendtop .trendtop_left {
  display: inline-block;
  color: #fff;
  padding: 0 0.4rem 0 0;
  position: relative;
  max-width: 90%;
  font-size: 15px;
  font-weight: 700;
}
.trendtop .trendtop_left .number {
  font-size: 13px;
  font-weight: normal;
  opacity: 0.7;
  line-height: 1;
}
.trendtop .trendtop_left::after {
  position: absolute;
  content: "";
  width: 0.14rem;
  height: 0.14rem;
  border-top: 2px solid #fff;
  border-right: 2px solid #fff;
  transform: rotate(45deg);
  top: 50%;
  margin-top: -0.09rem;
  right: 0.1rem;
  -webkit-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}
.trendtop .trendtop_left.on::after {
  -webkit-transform: rotate(135deg);
  -moz-transform: rotate(135deg);
  -o-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
  transform: rotate(135deg);
}
.trendtop .trendtop_right {
  float: right;
  overflow: hidden;
  color: #fff;
  opacity: 0.5;
  font-weight: 700;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  position: relative;
  padding-right: 16px;
}
.trendtop .trendtop_right .img1 {
  width: 12px;
  height: 12px;
  float: right;
  margin-left: 5px;
  position: absolute;
  top: 50%;
  margin-top: -6px;
  right: 0;
}
.trendtop .trendtop_right .img1.on {
  animation: run 2s linear 0s infinite;
}

/*top end*/

/*时间选择*/
.times {
  padding-top: 0rem;
  text-align: center;
}
.times .tim {
  width: 3.1rem;
  padding: 0.25rem 0;
  display: inline-block;
  border-radius: 0.1rem;
  background: #fff;
  margin: 0.4rem 0.1rem 0 0.1rem;
  font-size: 16px;
}
.foremail {
  width: 6.4rem;
  margin: 0.4rem auto;
  border-radius: 0.1rem;
  background: #fff;
  overflow: hidden;
}
.foremail input {
  width: 100%;
  text-indent: 0.1rem;
  font-size: 16px;
  color: #333;
  padding: 0.25rem 0;
  float: left;
}
/*时间选择 end*/
.doexcel {
  width: 6.4rem;
  margin: 0 auto;
  border-radius: 0.1rem;
  text-align: center;
  padding: 0.2rem 0;
  font-size: 16px;
  background: #2255d2;
  color: #fff;
}

.ctn {
  height: calc(100% - 117px);
  overflow-y: scroll;
}

.footer {
}

.tips {
  width: 6.4rem;
  margin: 0 auto;
  font-size: 12px;
  color: red;
  margin-top: 10px;
}
</style>
